import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {Auth} from '../../../../shared/services/aws';
import Select from '../../../../shared/ui/Select';
import formatRoleName from '../../../models/utilities/formatRoleName';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import rootActionCreators from '../../../store/action-creators';
import subDepartmentsActionCreators from "../../../store/sub-departments/action-creators";
import departmentSettingsSelectors from "../../../store/department-settings/selectors";
import {clearSharedStorage} from "../../../../shared/services/shared-storage";

const CommonNav = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function handleLogout() {
    Auth.signOut();
    props.resetUserSession();
    clearSharedStorage()
      .then(() => {
        window.location.href = 'https://departmentware.com';
      })
  }

  function handleSwitchRole(role) {
    props.switchRole(props.userContext.userGuid, role.guid).then(() => {
      window.location.href = role.scope === 'admin'? '/admin/dashboard':'/dashboard';
    });
  }

  function handleSwitchDepartment(department) {
    props.switchSubDepartment(department)
      .then(() => {
        window.location.href = props.userContext.scope === 'admin'? '/admin/dashboard':'/dashboard';
      });
  }

  function listSubDepartmentes(subDepartments) {
    if(!props.settings) {
      return subDepartments
    }
    if(!props.settings.mainDepartment) {
      return subDepartments
    }
    if(subDepartments) {
      return subDepartments.map(sd => {
        if(sd.guid === props.userContext.masterDepartment) {
          return {
            ...sd,
            name: props.settings.mainDepartment
          }
        }

        return sd
      })
    }
    return subDepartments
  }


  const isMasterDepartment = !listSubDepartmentes(props.subDepartments).find(d => d.guid === props.userContext.departmentGuid)
  const subDepartment = listSubDepartmentes(props.subDepartments).find(d => d.guid === props.userContext.departmentGuid)

  // ----------------------
  // Render
  // ----------------------

  return (
    <Fragment>
      <NavLink
        activeClassName="active"
        className="navigation-item"
        to="/dashboard"
      >
        <i className="fa fa-tachometer"/> Dashboard
      </NavLink>
      {props.userContext.hasScope(['fto']) && (
        <Fragment>
          <NavLink activeClassName="active" className="navigation-item" to="/task-training">
            <i className="fa fa-tasks"/> My {props.oitShortLabel} Tasks
          </NavLink>

          <NavLink
            activeClassName="active"
            className="navigation-item"
            to="/my-oits"
          >
            <i className="fa fa-users"/> My {props.oitShortLabel} Forms
          </NavLink>

        </Fragment>
      )}

      {props.userContext.hasScope(['oit']) ? (
        <Fragment>
          <NavLink
            activeClassName="active"
            className="navigation-item"
            to="/my-completed-reports"
          >
            <i className="fa fa-file-text"/> My Completed Forms
          </NavLink>
          <NavLink activeClassName="active" className="navigation-item" to="/task-training">
            <i className="fa fa-tasks"/> My Tasks
          </NavLink>
          <NavLink
            activeClassName="active"
            className="navigation-item"
            to="/my-training-program"
          >
            <i className="fa fa-users"/> My Forms Details
          </NavLink>
          {props.areTestsEnabled && <NavLink
            activeClassName="active"
            className="navigation-item"
            to="/tests/index"
          >
            <i className="fa fa-list-alt"/> Tests
          </NavLink>}
        </Fragment>
      ) : (
        <NavLink
          activeClassName="active"
          className="navigation-item"
          to="/oits"
        >
          <i className="fa fa-users"/> ALL {props.oitShortLabel} Forms
        </NavLink>
      )}

      {props.children}

      {props.canViewAnayitics && props.canViewObservationAnalytics && (
        <NavLink activeClassName="active" className="navigation-item" to="/oit-analytics">
          <i className="fa fa-line-chart"/> Observation Analytics
        </NavLink>
      )}

      {props.userContext.hasScope(['ftoc', 'sup', 'cstaff', 'chief']) &&
        (<NavLink activeClassName="active" className="navigation-item" to="/fto-analytics">
          <i className="fa fa-line-chart"/> {props.ftoShortLabel} Analytics
        </NavLink>)}
      {props.userContext.hasScope(['fto', 'ftoc', 'sup', 'cstaff', 'chief']) && (
        <Fragment>
          {props.areTestsEnabled && <NavLink
            exact
            activeClassName="active"
            className="navigation-item"
            to="/tests/index"
          >
            <i className="fa fa-list-alt"/> View Test Results
          </NavLink>}
          {props.areTestsEnabled && (props.testsForGrade && props.testsForGrade.length
            ? <NavLink
              exact
              activeClassName="active"
              className="navigation-item"
              to="/tests/for-grade"
            >
              <i className="fa fa-pencil-square-o"/> <span
              className="menu-notification">{props.testsForGrade.length}</span> Grade tests
            </NavLink> : (
              <NavLink
                exact
                activeClassName="active"
                className="navigation-item"
                to="/tests/for-grade"
              >
                <i className="fa fa-pencil-square-o"/> No tests for grade
              </NavLink>
            ))}

        </Fragment>
      )}

      {props.userContext.hasScope('oit') && props.isOitAllowedToViewAnalyticsReport && <Fragment>
        <NavLink activeClassName="active" className="navigation-item" to="/oit-analytics">
          <i className="fa fa-line-chart"/> Observation Analytics
        </NavLink>
      </Fragment>}

      <Fragment>
        <NavLink
          activeClassName="active"
          className="navigation-item"
          to="/personal-schedule"
        >
          <i className="fa fa-calendar"/> Personal schedule
        </NavLink>

      </Fragment>

      {props.userContext.hasScope(['depadmin', 'ftoc', 'sup', 'cstaff', 'chief']) && (
        <NavLink activeClassName="active" className="navigation-item" to="/fto-calendar">
          <i className="fa fa-calendar"/> Master {props.ftoShortLabel} Calendar
        </NavLink>
      )}

      <div className="navigation-separator"/>
      {listSubDepartmentes(props.subDepartments).length
        ? (
          <Fragment>
            <p className="navigation-subline">Division</p>
            <Select
              value={isMasterDepartment ? (props.settings && props.settings.mainDepartment ? props.settings.mainDepartment : 'Main Department' ): subDepartment.name}
              icon="building"
              placeholder={props.settings && props.settings.mainDepartment ? props.settings.mainDepartment : 'Main Department'}
              items={[...listSubDepartmentes(props.subDepartments)]}
              onSelect={dep => handleSwitchDepartment(dep)}
            />
          </Fragment>
        )
        : null
      }

      <p className="navigation-subline">{props.userContext.fullName}</p>

      {props.userContext.roles.length > 1 ? (
        <Select
          value={props.userContext.scope}
          items={props.userContext.roles}
          formatValue={formatRoleName}
          onSelect={role => handleSwitchRole(role)}
        />
      ) : (
        <p className="navigation-roleline">
          {formatRoleName(props.userContext.scope)}
        </p>
      )}

      <NavLink
        activeClassName="active"
        className="navigation-item"
        to="/department-uploads"
      >
        <i className="fa fa-file"/> Department files
      </NavLink>


      <NavLink
        activeClassName="active"
        className="navigation-item"
        to="/my-profile"
      >
        <i className="fa fa-id-card-o"/> My Profile
      </NavLink>

      {props.userContext.hasScope(['depadmin', 'ftoc', 'sup', 'cstaff', 'chief']) && (
        <NavLink
          activeClassName="active"
          className="navigation-item"
          to="/my-department"
        >
          <i className="fa fa-suitcase"/> My Department
        </NavLink>
      )}


      <div className="navigation-separator"/>
      {props.settings && props.settings.ftoGuidelines && props.ftoGuidelinesLink && (
        <a className="navigation-item" target="_blank" href={props.ftoGuidelinesLink}>
          <i
            className="fa fa-file-text"/> {props.settings.ftoGuidelinesLabel || props.ftoShortLabel + ' Scoring Guidelines'}
        </a>
      )}

      <a className="navigation-item" href="https://profile.departmentware.com">
        <i className="fa fa-sign-out"/> Switch Apps
      </a>

      <a className="navigation-item" href="#" onClick={handleLogout}>
        <i className="fa fa-sign-out"/> Logout
      </a>
    </Fragment>
  );
};

// ----------------------
// Redux/Router Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    settings: state.departmentSettings.settings,
    subDepartments: state.subDepartments.list,
    testsForGrade: state.tests.forGrade,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    canViewAnayitics: departmentSettingsSelectors.canViewAnayitics(state),
    canViewObservationAnalytics: departmentSettingsSelectors.canViewObservationAnalytics(state),
    areTestsEnabled: departmentSettingsSelectors.areTestsEnabled(state),
    isOitAllowedToViewAnalyticsReport: departmentSettingsSelectors.isOitAllowedToViewAnalyticsReport(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetUserSession: () => {
      return dispatch(rootActionCreators.resetRootState());
    },
    switchRole: (userId, roleId) => {
      return dispatch(commonActionCreators.switchRole(userId, roleId));
    },
    switchSubDepartment: (dep) => {
      return dispatch(subDepartmentsActionCreators.switchSubDepartment(dep.guid));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonNav);
